module.exports = __webpack_public_path__ + "img/水印logo--高自定义.fdc17143.png";